import { action as apiAction } from 'api/Api'
import {
  setName as setCardName
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  name: string
}

export default (payload: Payload) => async dispatch => {
  const { id, name } = payload

  const optimisticAction = optimisticDispatch(dispatch, setCardName({
    id,
    name: name.trim()
  }))

  try {
    await apiAction('RenameCard', {
      id,
      name: name.trim()
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()
    
    if (error.code !== 303) { // NoChange
      throw error
    }
  }
}
